import { render, staticRenderFns } from "./AdminTeatroSelector.vue?vue&type=template&id=6b7f3672&scoped=true"
import script from "./AdminTeatroSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTeatroSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminTeatroSelector.vue?vue&type=style&index=0&id=6b7f3672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f3672",
  null
  
)

export default component.exports